//angular
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
//others
import * as auth0 from 'auth0-js';
//app
import { AppAnimations } from '../../../_shared/animations';
import { AUTH_CONFIG_DESKTOP } from '../../../../environments/environment';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  animations: [AppAnimations],
  host: { '[@slideInRightAnimation]': '', 'class': 'display flex' }
})

export class ForgotComponent {
  dateYear: any = new Date().getFullYear();
  messageStatus: string = 'hidden';
  resCode: number = 400;
  resMessage: string;

  // Configure Auth0
  auth0 = new auth0.WebAuth({
    domain: AUTH_CONFIG_DESKTOP.domain,
    clientID: AUTH_CONFIG_DESKTOP.clientID,
    redirectUri: AUTH_CONFIG_DESKTOP.callbackURL,
    responseType: AUTH_CONFIG_DESKTOP.responseType,
    scope: AUTH_CONFIG_DESKTOP.scope
  });

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer
  ) {
    this._iconRegistry.addSvgIcon('logo-rebillia', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/logo-rebillia.svg'));
    this._iconRegistry.addSvgIcon('ico-back', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-01.svg'));
    this._iconRegistry.addSvgIcon('ico-error', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-error-07.svg'));
    this._iconRegistry.addSvgIcon('ico-success', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-check-02.svg'));
  }

  onSubmit(_email){
    this.auth0.changePassword({
      connection: AUTH_CONFIG_DESKTOP.connection,
      email: _email
    }, res => {
      if (res) {
        console.log(res);
        this.resCode = 404;
        this.resMessage = res.errorDescription;
      }else {
        this.resCode = 200;
      }
      this.messageStatus = 'visible';
    })
  }

}
